import React, { useState, useEffect } from "react";
import workspace from "../assets/workspace.webp";
import tick from "../assets/Tick.webp";
import training from "../assets/Training-1.webp";
import complaince from "../assets/Complaince-2.webp";
import ptr from "../assets/ptr-3.webp";
import global from "../assets/global-4.webp";
import aiquestions from "../assets/ai-que.webp";
import chatbasedlearning from "../assets/chat-based.webp";
import customdashboards from "../assets/custom-dashboard.webp";
import how from "../assets/how it works.svg";
import ContactSection from "../pages/contact";
import left from "../assets/decoration-left.webp";
import right from "../assets/decoration-right.webp";
import linkIcon from "../assets/link.webp";
import pinkoval from "../assets/pinkoval.webp";
import mobileHow from "../assets/how it works - mobile.svg";
import workspaceMobile from "../assets/workspacemobile.webp";
import knudge from "../assets/Knudge.png";
import Popup from "../pages/Demo";

const platformFeatures = [
  {
    id: 1,
    title: "AI Questions from Pillars",
    image: aiquestions,
    benefits: [
      "Open questions to test knowledge",
      "AI core values from document",
      "Tailored questions for every scenario",
    ],
  },
  {
    id: 2,
    title: "Chat based learning",
    image: chatbasedlearning,
    benefits: [
      "AI-powered feedback",
      "Spaced repetition and reinforcement",
      "Email-centered learning",
    ],
  },
  {
    id: 3,
    title: "Custom Dashboards",
    image: customdashboards,
    benefits: [
      "Target knowledge gaps",
      "Enhance retention for struggling learners.",
      "Understand team alignment with goals",
    ],
  },
];
const ldFeatures = [
  {
    id: 1,
    title: "Onboarding & Training Reinforcement",
    icon: training,
    description:
      "Turn static onboarding documents into bite-sized, daily questions that reinforce key concepts. Help new hires retain knowledge without overwhelming them.",
  },
  {
    id: 2,
    title: "Compliance & Policy Awareness",
    icon: complaince,
    description:
      "Ensure your team stays up to date with policies and regulations through regular, automated nudges. No more forgotten compliance trainings or costly oversights.",
  },
  {
    id: 3,
    title: "Product Knowledge Retention",
    icon: ptr,
    description:
      "Keep your customer-facing teams sharp by continuously reinforcing product features, updates, and use cases—straight from your product docs and manuals.",
  },
  {
    id: 4,
    title: "Distributed Team Enablement",
    icon: global,
    description:
      "Engage remote or global teams with consistent knowledge nudges, regardless of time zones. Reinforce company knowledge without requiring synchronous sessions.",
  },
];

export function Knudge() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleBookDemoClick = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const titles = document.querySelector(".animate-text")?.children;
    if (!titles) return;

    const txtsLen = titles.length;
    let index = 0;
    const textInTimer = 3000;
    const textOutTimer = 2800;

    function animateText() {
      for (let i = 0; i < txtsLen; i++) {
        titles[i].classList.remove("text-in", "text-out");
      }
      titles[index].classList.add("text-in");

      setTimeout(() => {
        titles[index].classList.add("text-out");
      }, textOutTimer);

      setTimeout(() => {
        index = index === txtsLen - 1 ? 0 : index + 1;
        animateText();
      }, textInTimer);
    }

    animateText();
  }, []);

  const handleSeeHowItWorksClick = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      const offsetTop = contactSection.offsetTop - 80; // Adjust offset as needed
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };
  return (
    <div className="bg-white font-display mt-10">
      <section className="min-h-screen bg-gradient-to-b-custom text-white text-center relative overflow-hidden flex flex-col">
        <div className="container mx-auto px-5 flex-1 flex flex-col">
          <div className="flex-1 flex flex-col justify-center min-h-0">
            <h2 className="font-medium text-[18px] md:text-[36px]  leading-[76.8px] 2xl:leading-[96px] tracking-[-0.04em] -mb-2 pt-8 md:pt-16 2xl:pt-24">
              Knowledge Nudge
            </h2>
            <div className="flex flex-col md:flex-row justify-center items-center mb-4 md:mb-6 2xl:mb-8 text-center md:text-left">
              <h1 className="text-[30px] md:text-6xl font-bold mb-2 md:mb-0 2xl:leading-[1.1] 2xl:whitespace-nowrap text-white">
                Reinforce Learning,
              </h1>
              <span className="word-slider md:ml-2">
                <div className="animate-text text-[30px] md:text-6xl font-bold w-full md:w-[350px] text-center md:text-left">
                  <span className="block">Effortlessly</span>
                  <span className="block">Seamlessly</span>
                  <span className="block">Quickly</span>
                </div>
              </span>
            </div>

            {/* Description text - responsive scaling */}
            <p className="text-[16px] md:text-base 2xl:text-xl max-w-[1094px] 2xl:max-w-[1400px] mx-auto mb-6 md:mb-8 2xl:mb-12 2xl:leading-relaxed">
              Training doesn't end when the session does, that's where it
              begins. Personalized nudges to help
              <br className="hidden md:inline" />
              your team retain, apply, and reflect on what they've learned.
            </p>

            {/* CTA Button - responsive scaling */}
            <button
              onClick={handleBookDemoClick}
              className="bg-[#C62B6D] hover:bg-pink-600 text-[16px] 2xl:text-lg text-white font-semibold py-3 px-6 2xl:py-4 2xl:px-8 rounded-lg 2xl:rounded-xl transition duration-300 mb-6 md:mb-10 2xl:mb-16 w-auto mx-auto"
            >
              Book Your Demo Now
            </button>
          </div>

          <div className="relative w-full flex justify-center items-end flex-shrink-0">
            {/* Left background image - responsive scaling */}
            <img
              src={left}
              alt="decor-left"
              className="
              absolute bottom-0 -left-4 2xl:-left-8 z-0 opacity-10
              w-[200px] h-[180px]
              md:w-[376px] md:h-[300px]
              2xl:w-[500px] 2xl:h-[400px]
            "
            />

            {/* Right background image - responsive scaling */}
            <img
              src={right}
              alt="decor-right"
              className="
              absolute bottom-0 -right-4 2xl:-right-8 z-0
              w-[200px] h-[180px]
              md:w-[376px] md:h-[300px]
              2xl:w-[500px] 2xl:h-[400px]
            "
            />

            {/* Pink oval mask background */}
            <img
              src={pinkoval}
              alt="pink oval"
              className="absolute bottom-0 z-0 w-full max-w-full pointer-events-none"
              style={{
                transform: "translateY(50%)",
                maskImage: "linear-gradient(to top, transparent 0%, black 60%)",
                WebkitMaskImage:
                  "linear-gradient(to top, transparent 0%, black 60%)",
                opacity: 1,
              }}
            />

            {/* Workspace image for mobile - responsive scaling */}
            <img
              src={knudge}
              alt="Workspace Mobile"
              className="
              block sm:hidden 
              relative z-10 
              w-[353px] h-[228px] rounded-t-[7.61px] mt-4 md:mt-8
              max-w-[90vw] h-auto
            "
            />

            {/* Workspace image for desktop and 2xl - responsive scaling */}
            <img
              src={knudge}
              alt="Workspace"
              className="
              hidden sm:block 
              relative z-10 
              w-[80%] max-w-[900px] 2xl:max-w-[1200px] h-auto 
              rounded-t-[29px] 2xl:rounded-t-[40px]
            "
            />
          </div>
        </div>
      </section>

      <section className="border-t border-gray-200">
        <div className="container mx-auto px-5 2xl:py-16 py-12">
          <h2 className="md:text-4xl 2xl:text-5xl text-[28px] font-semibold text-center mb-16">
            How it works?
          </h2>

          {/* Desktop image */}
          <img
            src={how}
            alt="How it works"
            className="hidden md:block w-full max-w-[1094px] 2xl:max-w-[1400px] mx-auto mb-8"
          />

          {/* Mobile image */}
          <img
            src={mobileHow}
            alt="How it works mobile"
            className="block md:hidden w-full max-w-[1094px] 2xl:max-w-[1400px] mx-auto mb-8"
          />
        </div>
      </section>
      <section
        className="py-12 2xl:py-16"
        style={{
          background:
            "linear-gradient(180deg, rgba(255, 235, 243, 0.4) 3.31%, rgba(255, 235, 243, 0) 106.28%)",
        }}
      >
        <div className="container mx-auto px-5 flex flex-col items-center">
          <h2 className="md:text-4xl 2xl:text-5xl text-[28px] font-semibold text-center mb-8">
            Frictionless learning, all within your Inbox, Teams or Whatsapp
          </h2>
          <div className="w-full max-w-[800px] aspect-video rounded-xl overflow-hidden shadow-lg">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/tSIIkTui-Bg?si=P6XpIvNMj5Vtgjfe&autoplay=1&mute=1"
              title="Frictionless learning video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </section>

      <section
        className="py-12 2xl:py-16"
        style={{
          background:
            "linear-gradient(180deg, rgba(212, 222, 255, 0.4) 3.31%, rgba(212, 222, 255, 0) 106.28%)",
        }}
      >
        <div className="container mx-auto px-5">
          {/* ✅ Center-aligned heading on all screens */}
          <h2 className="md:text-4xl 2xl:text-5xl text-[28px] font-semibold text-center mb-10">
            One platform - 3 Clicks - all your L&D Needs
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 px-4 md:px-8 gap-4">
            {platformFeatures.map((feature) => (
              <div
                key={feature.id}
                className="flex flex-col gap-5 relative text-left  items-center"
              >
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-[246.51px] h-[252.63px]"
                />

                <h3 className="md:text-2xl 2xl:text-3xl text-[22px] font-semibold">
                  {feature.title}
                </h3>

                <ul className="space-y-3">
                  {feature.benefits.map((benefit, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <img src={tick} alt="check" className="w-6" />
                      <span className="md:text-base 2xl:text-[20px] text-[16px] text-[#5a5a5a]">
                        {benefit}
                      </span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  onClick={handleSeeHowItWorksClick}
                  className="text-[#0000FF] 2xl:text-[20px] text-base font-semibold flex items-center gap-1 hover:underline"
                >
                  See how it works
                  <img src={linkIcon} alt="link icon" className="w-4 h-4" />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-gradient-to-b px-4 md:px-24 from-[rgba(255,235,243,0.4)] to-[rgba(255,235,243,0)]">
        <div className="container mx-auto px-4">
          <h2 className="md:text-4xl text-[28px] 2xl:text-5xl font-semibold text-center md:mb-16 mb-8">
            Built for L&D, Loved by Learners
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 md:gap-16 gap-8">
            {ldFeatures.map((feature) => (
              <div key={feature.id} className="flex flex-col gap-4">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="md:w-[60px] w-[32px]"
                />
                <div className="md:space-y-4 space-y-4">
                  <h3 className="md:text-3xl 2xl:text-4xl text-[22px] font-semibold text-left md:text-left">
                    {feature.title}
                  </h3>
                  <p className="md:text-base 2xl:text-[20px] text-[16px] text-[#5a5a5a] text-left md:text-left">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div id="contact">
        <ContactSection />
      </div>

      {/* Popup Component */}
      {isPopupOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="relative bg-[#F1F6FF] p-8 lg:px-10 rounded-lg max-h-screen max-w-md w-full mx-4">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closePopup}
            >
              <svg
                className="lg:w-6 lg:h-6 w-4 h-4 cursor-pointer"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            <Popup utmContent="knudge-demo-request" />
          </div>
        </div>
      )}
    </div>
  );
}

export default Knudge;
